import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddUserPropertiesMutationVariables = Types.Exact<{
  objects: Array<Types.User_Properties_Insert_Input> | Types.User_Properties_Insert_Input;
}>;


export type AddUserPropertiesMutation = { __typename?: 'mutation_root', insert_user_properties?: { __typename?: 'user_properties_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, organizationImageURL?: string | null } | null } | null }> } | null };


export const AddUserPropertiesDocument = gql`
    mutation addUserProperties($objects: [user_properties_insert_input!]!) {
  insert_user_properties(
    objects: $objects
    on_conflict: {constraint: user_properties_user_id_property_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        organization {
          id
          name
          organizationImageURL
        }
      }
    }
  }
}
    `;
export type AddUserPropertiesMutationFn = Apollo.MutationFunction<AddUserPropertiesMutation, AddUserPropertiesMutationVariables>;

/**
 * __useAddUserPropertiesMutation__
 *
 * To run a mutation, you first call `useAddUserPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPropertiesMutation, { data, loading, error }] = useAddUserPropertiesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddUserPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPropertiesMutation, AddUserPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPropertiesMutation, AddUserPropertiesMutationVariables>(AddUserPropertiesDocument, options);
      }
export type AddUserPropertiesMutationHookResult = ReturnType<typeof useAddUserPropertiesMutation>;
export type AddUserPropertiesMutationResult = Apollo.MutationResult<AddUserPropertiesMutation>;
export type AddUserPropertiesMutationOptions = Apollo.BaseMutationOptions<AddUserPropertiesMutation, AddUserPropertiesMutationVariables>;